import { ComponentProps, forwardRef } from "react";
import { cn } from "@/lib/utils";
import { editableBoxClasses } from "@/classes/editableBoxClasses";

interface EditableBoxProps extends ComponentProps<"div"> {
  direction?: "column" | "row";
}

// Styled components
export const EditableBox = forwardRef<HTMLDivElement, EditableBoxProps>(
  ({ direction, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      className={cn(
        editableBoxClasses.root,
        "bg-background mt-6.25 flex min-h-0 rounded px-3 py-2",
        direction === "column" ? "flex-col" : "flex-row",
        props.className,
      )}
    />
  ),
);

export const CourseStepDivider = (props: ComponentProps<"hr">) => {
  return (
    <hr
      {...props}
      className={cn("bg-primary-light mx-0 my-7.5 h-0.25 min-h-0.25 w-full border-0", props.className)}
    />
  );
};

export const CourseStepPaddingWrapper = (props: ComponentProps<"div">) => (
  <div {...props} className={cn("flex min-h-0 flex-col px-8 py-0", props.className)} />
);

export const RadioCheck = forwardRef<HTMLInputElement, ComponentProps<"input">>((props, ref) => {
  return (
    <input
      {...props}
      type="radio"
      className={cn(
        "mt-0 size-6 cursor-pointer appearance-none bg-[url(/images/icons/radio-check.svg)] bg-contain bg-no-repeat opacity-50 saturate-0 checked:opacity-100 checked:saturate-100",
        props.className,
      )}
      ref={ref}
    />
  );
});
